<template>
  <!-- edit mode -->
  <vue-select
    v-model="model"
    :options="options"
    :name="name"
    :disabled="loading || disabled"
    label="Text"
    @input="
      (evt) => {
        $emit('update:modelValue', model);
      }
    "
    @search:blur="
      (evt) => {
        $emit('update:modelValue', model);
        $emit('change', true);
      }
    "
  />
</template>

<script>
import FormComponentMixin from './_FormComponentMixin';

export default {
  name: 'Dropdown',
  mixins: [FormComponentMixin],
  props: {
    options: {
      type: Array,
      default() {
        return [];
      }
    }
  }
};
</script>
